import { useState } from "react"
import { AndroidLogo } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { Card, CardHeader, CardHeaderTitle } from "@/components/ui/card"
import { SbotSimulatorDialog } from "@/modules/admin/advanced/components/sbot-simulator-dialog"

const SbotSimulator = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <Card className="h-fit w-92.5">
        <CardHeader>
          <CardHeaderTitle data-testid="card-header-title-content" className="flex items-center gap-4">
            Sbot Simulator
          </CardHeaderTitle>
          <div className="flex justify-end">
            <Button variant="tertiary" className="p-2" onClick={() => setIsDialogOpen(true)}>
              <AndroidLogo className="text-on-surface-subdued" />
            </Button>
          </div>
        </CardHeader>
      </Card>
      {isDialogOpen && (
        <SbotSimulatorDialog
          onClose={() => {
            setIsDialogOpen(false)
          }}
        />
      )}
    </>
  )
}

export { SbotSimulator }
